
import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-blue-600" style={{ fontFamily: '"Pacifico", serif' }}>
              琉球スタートアップ
            </h1>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="#services" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
              サービス
            </a>
            <a href="#features" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
              特徴
            </a>
            <a href="#portfolio" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
              制作事例
            </a>
            <a href="#pricing" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
              料金
            </a>
            <a href="#contact" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
              お問い合わせ
            </a>
            <Button size="sm" href="#contact">
              無料相談
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-blue-600 cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <a href="#services" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                サービス
              </a>
              <a href="#features" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                特徴
              </a>
              <a href="#portfolio" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                制作事例
              </a>
              <a href="#pricing" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                料金
              </a>
              <a href="#contact" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                お問い合わせ
              </a>
              <Button size="sm" href="#contact" className="w-fit">
                無料相談
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
